
  import { Component, Vue } from 'vue-property-decorator'
  import BackNav from '@/components/BackNav/index.vue'
  import { editMicroStoreInfo } from '@/api/store'
  import { Debounce } from '@/core/decorator'
  
  @Component({
    name: 'EditPickupTime',
  })
  export default class EditPickupTime extends Vue {
    pickupStartTime = ''
    pickupEndTime = ''
    storeId = ''
    
    get currentTime() {
      return this.pickerType === 1 ? this.pickupStartTime : this.pickupEndTime
    }

    pickerType = 1 // 默认选中开始时间
  
    created() {
      // 从路由参数获取初始值
      this.pickupStartTime = this.$route.query.startTime as string
      this.pickupEndTime = this.$route.query.endTime as string
    }
  
    @Debounce(500)
    async onSave() {
      if (!this.pickupStartTime || !this.pickupEndTime) {
        this.$toast('请选择完整的提货时间')
        return
      }
      try {
        const res = await editMicroStoreInfo({
            id: this.storeId,
            takeStartTime: `${this.pickupStartTime}:00`,
            takeEndTime: `${this.pickupEndTime}:00`
        })
        if (res.code === '000000') {
            this.$toast.success('保存成功')
            setTimeout(() => {
                this.$router.back()
            }, 1000)
        } else {
            this.$toast.fail(res.msg || '保存失败')
        }
      } catch (e) {
        console.error(e)
        this.$toast.fail('保存失败')
      }
    }
    
    togglePickerType(num: number) {
      this.pickerType = num
    }
    
    onChange(picker) {
      // 实时更新显示的时间
      const values = picker.getValues()
      const timeStr = values.join(':')
      
      if (this.pickerType === 1) {
        this.pickupStartTime = timeStr
      } else if (this.pickerType === 2) {
        this.pickupEndTime = timeStr
      }
    }
  }
  